import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=57f02dcb&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=57f02dcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f02dcb",
  null
  
)

export default component.exports